import React from "react";
import { Collapse } from "antd";
import { AddMemoryButton } from "../../components";

const MemoriesTabPane: React.FC = (props) => {
  return (
    <Collapse
      className="bg-transparent border-0 mt-2 mb-8"
      defaultActiveKey={["1", "2", "3"]}
    >
      <Collapse.Panel className="clear-collapse" header="Photos" key="1">
        <AddMemoryButton label="Add a photo" memoryType="image" />
      </Collapse.Panel>
      <Collapse.Panel className="clear-collapse" header="Documents" key="2">
        <AddMemoryButton label="Add a document" memoryType="document" />
      </Collapse.Panel>
      <Collapse.Panel className="clear-collapse" header="Audios" key="3">
        <AddMemoryButton label="Add an audio" memoryType="audio" />
      </Collapse.Panel>
    </Collapse>
  );
};

export default MemoriesTabPane;
